import ACTIONS from '@/store/storeActions';

import dayjs from 'dayjs';
import LoadingState from '@/api/LoadingState';

class BusinessLogicOverview {
  constructor(vue) {
    this.vue = vue;
  }

  setExercise(exerciseId) {
    this.vue.$store.dispatch(ACTIONS.SET_CURRENT_EXERCISE, exerciseId);
    const documentsLoadingState = this.vue.$store.state.exerciseDocuments.loadingState.documents;
    if (documentsLoadingState !== LoadingState.LOADING || documentsLoadingState !== LoadingState.LOADED) {
      this.vue.$api.exerciseDocuments.getDocumentNames(exerciseId);
    }
    if (this.vue.$route.name !== 'notes') this.vue.$router.push({ name: 'notes' })
  }
}

export default BusinessLogicOverview;
